import InnerHTMLDiv from '../common/inner-html-div.component';
import { mergeStyling } from '../common-functions';
import { Popover, type PopoverAlign, PopoverContent, type PopoverSide, PopoverTrigger } from '../popover/popover';

interface HelpDescriptionProps {
  description: string;
}

const HelpDescription = ({ description }: HelpDescriptionProps) => {
  return <InnerHTMLDiv html={description} />;
};

export interface HelpComponentProps {
  description: string;
  align?: PopoverAlign;
  side?: PopoverSide;
  className?: string;
}

export default function HelpComponent({ description, align = 'end', side, className }: HelpComponentProps) {
  return (
    <Popover>
      <PopoverTrigger
        openOnHover
        className={mergeStyling(
          'size-4 cursor-default rounded-full bg-info text-center font-bold text-mono-1 text-xs',
          className
        )}
      >
        <span>?</span>
      </PopoverTrigger>
      <PopoverContent
        align={align}
        side={side}
        className="max-h-[calc(100dvh-2rem)] w-auto max-w-[calc(100vw-2rem)] sm:max-w-prose"
      >
        <div className="odin help-links overflow-y-auto">
          <HelpDescription description={description} />
        </div>
      </PopoverContent>
    </Popover>
  );
}
